const subscriptionForms = document.querySelectorAll('.js-subscription-form');
const actionButtons = document.querySelectorAll('.js-subscription-action');

/**
 * Add subscriber on form submit.
 *
 * @since       1.0.0
 */
async function addSubscriber(e) {
  e.preventDefault();

  const button = e.target.querySelector('button');
  const form = e.target;
  const formData = new FormData(form);
  const terms = {};
  // Aggregate all terms into an array.
  for (const [name, value] of formData) {
    if (name.includes('sqpx_es_terms')) {
      terms[name] = formData.getAll(name);
    }
  }

  try {
    button.disabled = true;
    button.setAttribute('data-loading', 'true');
    form.setAttribute('data-loading', 'true');
    updateFormMessage(form, '', '');

    const response = await fetch(sqpxSubscriptions.admin_ajax_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
      body: new URLSearchParams({
        action: 'add_subscriber',
        form_nonce: formData.get('sqpx_nonce_field_public'),
        honeypot: formData.get('sqpx_email_confirm'),
        email: formData.get('sqpx_es_email_address'),
        first_name: formData.get('sqpx_es_first_name'),
        last_name: formData.get('sqpx_es_last_name'),
        post_id: formData.get('sqpx_es_post_id'),
        post_type: formData.get('sqpx_es_post_type'),
        privacy: formData.get('sqpx_es_privacy'),
        language: formData.get('sqpx_es_language'),
        logic: formData.get('sqpx_es_logic'),
        terms: JSON.stringify(terms),
        captcha: formData.get('sqpx_captcha'),
      }),
      credentials: 'same-origin',
    });
    const data = await response.json();
    if (data.success) {
      button.disabled = false;
      button.setAttribute('data-loading', 'false');
      form.setAttribute('data-loading', 'false');
      updateFormMessage(form, 'success', data.data.message);
      e.target.reset();
      e.target.setAttribute('data-completed', 'true');

      // Dispath custom event to reset form select2 fields.
      const event = new Event('formReset');
      e.target.dispatchEvent(event);
    } else {
      const err = new Error(data.data.message);
      throw err;
    }
  } catch (error) {
    button.setAttribute('data-loading', 'false');
    form.setAttribute('data-loading', 'false');
    button.disabled = false;
    updateFormMessage(e.target, 'error', error);
  }
}

function updateFormMessage(form, type, message) {
  const messageContainer = form.previousElementSibling;
  messageContainer.textContent = message;
  messageContainer.setAttribute('data-visible', 'true');
  messageContainer.setAttribute('data-type', type);
}

/**
 * Manage user actions on subscription table.
 *
 * @since       1.0.0
 */
async function manageUserAction(e) {
  e.preventDefault();

  const button = e.currentTarget;
  const subscriptionAction = button.getAttribute('data-action');
  const subscriptionId = button.getAttribute('data-id');
  const subscriptionEmail = button.getAttribute('data-email');

  try {
    button.disabled = true;
    button.setAttribute('data-loading', 'true');

    const response = await fetch(sqpxSubscriptions.admin_ajax_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
      body: new URLSearchParams({
        action: 'manage_subscription_actions',
        subscription_id: subscriptionId,
        subscription_email: subscriptionEmail,
        subscription_action: subscriptionAction,
        subscription_actions_nonce:
          sqpxSubscriptions.subscription_actions_nonce,
      }),
      credentials: 'same-origin',
    });
    const data = await response.json();
    if (data.success) {
      button.disabled = false;
      button.setAttribute('data-loading', 'false');

      if (subscriptionAction === 'verify') {
        alert(data.data.message);
      } else if (subscriptionAction === 'pause') {
        button.textContent = sqpxSubscriptions.resume_label;
        button.setAttribute('data-action', 'resume');
      } else if (subscriptionAction === 'resume') {
        button.textContent = sqpxSubscriptions.pause_label;
        button.setAttribute('data-action', 'pause');
      } else if (subscriptionAction === 'unsubscribe') {
        button.closest('tr').remove();
      }
    } else {
      const err = new Error(data.data.message);
      throw err;
    }
  } catch (error) {
    alert(error);
    button.setAttribute('data-loading', 'false');
    button.disabled = false;
  }
}

if (actionButtons) {
  actionButtons.forEach((button) => {
    button.addEventListener('click', manageUserAction);
  });
}
if (subscriptionForms) {
  subscriptionForms.forEach((form) => {
    form.addEventListener('submit', addSubscriber);
  });
}
